import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import classNames from 'classnames';

const BOTTOM_DROPDOWN_INDENT = 18;

class DropdownContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      maxHeight: '100%',
    };

    this.setDropdownHeight = this.setDropdownHeight.bind(this);
    this.onWindowResize = throttle(this.setDropdownHeight, 300);
    this.dropdown = createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize, false);
    this.setDropdownHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize, false);
  }

  setDropdownHeight() {
    const bounds = this.dropdown.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const { maxHeight } = this.state;
    const newMaxHeight = windowHeight - bounds.top - BOTTOM_DROPDOWN_INDENT;

    if (newMaxHeight !== maxHeight) {
      this.setState({
        maxHeight: newMaxHeight,
      });
    }
  }

  render() {
    const { children, className, ...dropdownContentProps } = this.props;
    const { maxHeight } = this.state;
    const dropdownClass = classNames('ws-dropdown__content', className);
    return (
      <div className="ws-dropdown__content-wrap">
        <div
          style={{ maxHeight }}
          ref={this.dropdown}
          className={dropdownClass}
          {...dropdownContentProps}
        >
          {children}
        </div>
      </div>
    );
  }
}

DropdownContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

DropdownContent.defaultProps = {
  className: '',
};

export default DropdownContent;
